export enum MachineClassification {
  STAND_ALONE = 'Stand-Alone',
  GATEWAY = 'Gateway',
  GATEWAY_CONNECTED_DEVICE = 'Gateway-Connected-Device',
}
